<template>
  <div class="container my-5 py-md-5">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row justify-content-center">
        <div class="col-md-10">
          <img class="img-fluid" src="static/img/header_uanl_facpsi.png" alt="">
        </div>
        <div class="col-md-8 mt-5">
          <div class="row justify-content-center">
          	<div class="col-12 text-right">
          		<h5><b>Folio No. </b>{{solicitud.idsolicitud}}</h5>
          	</div>
            <div class="col-12 mt-3 text-left">
              <h6><b>EL ALUMNO (A) </b>{{solicitud.nombre}}</h6>
            </div>
          	<div class="col-md-6 text-left">
              <h6><b>No. DE MATRICULA </b>{{solicitud.matricula}}</h6>
            </div>
            <div class="col-md-6 text-left">
              <h6><b>No. DE EXPEDIENTE </b>{{solicitud.idsolicitud}}</h6>
            </div>
            <div class="col-12 mt-3 text-left">
              <h6>
                <b>
                Presentó el EXAMEN PSICOMETRICO de POSGRADO correspondiente al Semestre
                </b>
                {{solicitud.periodo}}
                <b>
                  en este Departamento, requisito indispensable para continuar con los siguientes trámites.
                </b>
              </h6>
            </div>
            <div class="col-12 mt-3 text-center">
              
            </div>
            <div class="col-12 text-center">
              
            </div>
            <div class="col-md-6 mx-auto pt-5 my-5 border-bottom">
              
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 text-center">
          <button v-on:click="Imprimir">Imprimir</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading:'d-none',
      result:'',
      solicitud:{
        idsolicitud:"",
        nombre: "",
        matricula:"",
        periodo:"",
      }
    }
  },
  methods:{
    Imprimir(){
      window.print();
    },
  	Consultar(){
      this.Cargando();
      this.$http.get('solicitudes/info/personal')
      .then(respuesta=>{return respuesta.json()})
      .then(respuestaJson=>{
        if (respuestaJson.resp=='Excelente') {
          this.Listo();
          this.solicitud=respuestaJson.solicitud;
        }else{
          this.Sin_Nada();
          swal("¡Ups!",respuestaJson.resp, "error");  
        }
      })
      .catch(error=>{
        this.Sin_Nada();
        swal("Favor de Intentar mas tarde", "Problemas para cargar la información", "error");
      });
    },
  	Cargando(){
  		this.loading='';
  		this.result='d-none';
  	},
  	Listo(){
  		this.loading='d-none';
  		this.result='';
  	},
    Sin_Nada(){
      this.loading="d-none";
      this.result="d-none";
    }
  },
  created(){

  },
  mounted(){
  	this.Consultar();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Imprimir_Boleta_Examen.vue